<h1 mat-dialog-title>{{ "dg_return.ReturnTo" | translate }}</h1>

<div mat-dialog-content>
  <ngx-datatable
    #table
    class="material striped table-width shadow-none"
    [columnMode]="'force'"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [limit]="5"
    [rows]="dataSource"
    *ngIf="showTable"
    [scrollbarH]="true"
  >
    <ngx-datatable-column
      [sortable]="false"
      [width]="150"
      name="{{ 'dg_return.FileNo' | translate }}"
      prop="alphanum_Fileno"
    >
      <ng-template
        ngx-datatable-cell-template
        let-rowIndex="rowIndex"
        let-value="value"
        let-row="row"
      >
        {{ value }}
      </ng-template>
    </ngx-datatable-column>

    <!-- Event Column -->

    <ngx-datatable-column
      [sortable]="false"
      [width]="120"
      name="{{ 'dg_return.Process' | translate }}"
      prop="process"
    >
      <ng-template
        ngx-datatable-cell-template
        let-rowIndex="rowIndex"
        let-value="value"
        let-row="row"
      >
        {{ value }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [sortable]="false"
      [width]="100"
      name="{{ 'dg_return.Recipient' | translate }}"
      prop="recipient"
    >
      <ng-template
        ngx-datatable-cell-template
        let-rowIndex="rowIndex"
        let-value="value"
        let-row="row"
      >
        <div *ngIf="!row.showMsg">
          <mat-radio-group [(ngModel)]="row.selectedRadio">
            <div *ngFor="let r of row.recipient">
              <mat-radio-button [value]="r"
                >{{ r.empName }},{{ r.unitName }}</mat-radio-button
              >
            </div>
          </mat-radio-group>
        </div>

        <div *ngIf="row.showMsg">{{ "dg_return.NoPerson" | translate }}</div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>

<mat-dialog-actions align="end">
  <div class="buttons">
    <button
      mat-button
      mat-raised-button
      color="primary"
      class="two"
      preventDoubleClick
      (click)="onSend()"
      [disabled]="isButtonDisable()"
    >
      {{ "dg_return.Return" | translate }}
    </button>

    <button mat-raised-button mat-dialog-close class="one">
      {{ "dg_return.Cancel" | translate }}
    </button>
  </div>
</mat-dialog-actions>
